import * as React from 'react';
export const SelectRootContext = /*#__PURE__*/React.createContext(null);
export function useSelectRootContext() {
  const context = React.useContext(SelectRootContext);
  if (context === null) {
    throw new Error('useSelectRootContext must be used within a SelectRoot');
  }
  return context;
}